var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 60.994,
    viewBox: "0 0 61 60.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4177634_arrows_loop_process_round_icon",
    "data-name": "4177634_arrows_loop_process_round_icon",
    transform: "translate(-3 -3.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M35.1,33.379a26.065,26.065,0,0,1-4.293.352,25.526,25.526,0,0,1-17.667-7.038h3.59a2.346,2.346,0,1,0,0-4.692H7.346A2.346,2.346,0,0,0,5,24.346v9.385a2.346,2.346,0,0,0,4.692,0V29.883a30.289,30.289,0,0,0,21.115,8.54A30.64,30.64,0,0,0,35.9,38a2.38,2.38,0,1,0-.8-4.692Z",
    transform: "translate(2.692 25.574)",
    fill: "#efa462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M15.765,8.041A25.757,25.757,0,0,1,37.7,14.728H34.135a2.346,2.346,0,1,0,0,4.692H43.52a2.346,2.346,0,0,0,2.346-2.346V7.689a2.346,2.346,0,1,0-4.692,0V11.56A30.5,30.5,0,0,0,14.967,3.419a2.38,2.38,0,0,0,.8,4.692Z",
    transform: "translate(13.442 0)",
    fill: "#efa462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M8.513,38.606a25.808,25.808,0,0,1,8.563-26.3v3.425a2.346,2.346,0,1,0,4.692,0V6.346A2.346,2.346,0,0,0,19.423,4H10.038a2.346,2.346,0,0,0,0,4.692H14.05A30.5,30.5,0,0,0,3,32.154a30.875,30.875,0,0,0,.962,7.625,2.346,2.346,0,0,0,2.346,1.76h.587a2.346,2.346,0,0,0,1.619-2.933Z",
    transform: "translate(0 1.343)",
    fill: "#efa462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M32.731,44.99H28.719a30.5,30.5,0,0,0,11.05-23.462,30.219,30.219,0,0,0-.985-7.7,2.346,2.346,0,1,0-4.528,1.173,26.441,26.441,0,0,1,.821,6.522,25.808,25.808,0,0,1-9.385,19.848V37.951a2.346,2.346,0,0,0-4.692,0v9.385a2.346,2.346,0,0,0,2.346,2.346h9.385a2.346,2.346,0,0,0,0-4.692Z",
    transform: "translate(24.231 11.969)",
    fill: "#efa462"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.7b7ffd489b2ed4ac6fe55c580e34f0b0.svg";
export { ForwardRef as ReactComponent };